export const commonStyles = {
  components: {
    Checkbox: {
      baseStyle: {
        control: {
          bg: "white",
          _checked: {
            bg: "brand.primary",
            borderColor: "brand.primary",
          },
        },
      },
    },
    Button: {
      baseStyle: {
        color: "#000000",
        borderRadius: "8px",
      },
      variants: {
        primary: {
          _hover: {
            border: "none",
            bg: "brand.primary",
            boxShadow: "none",
            opacity: 1,
          },
          _focus: {
            border: "none",
            boxShadow: "none",
            outline: "none",
          },
          _active: {
            border: "none",
            boxShadow: "none",
            outline: "none",
          },
          _disabled: {
            bg: "brand.textInactive",
            pointerEvents: "none",
          },
        },
      },
      defaultProps: {
        variant: "primary",
      },
    },
    Table: {
      variants: {
        simple: {
          marginLeft: 0,
          tr: {
            td: {
              border: "none",
              paddingLeft: "0",
            },
            th: {
              border: "none",
              paddingLeft: "0",
            },
          },
        },
      },
    },
  },
};
